import React from 'react';
import { FiTarget, FiHeart, FiShield } from 'react-icons/fi';
import SEO from '../../components/SEO';

const AboutUsPage = () => {
    return (
        <div className="bg-slate-50 min-h-screen pb-24">
            <SEO
                title="About Us"
                description="Redefining trendy fashion in Sri Lanka with style, quality, and affordability. Learn more about Cider Clothings."
                url="/about"
            />
            {/* Hero Section */}
            <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 py-24 px-4 text-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                <div className="relative z-10">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight">
                        About Cider Clothings
                    </h1>
                    <p className="text-slate-300 text-lg md:text-xl max-w-2xl mx-auto font-medium">
                        Redefining trendy fashion in Sri Lanka with style, quality, and affordability.
                    </p>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-20">
                <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
                            <p className="text-gray-600 leading-relaxed mb-4">
                                Founded with a passion for modern aesthetics and the vibrant spirit of Sri Lanka, Cider Clothings was born to bridge the gap between high-end fashion trends and accessible pricing.
                            </p>
                            <p className="text-gray-600 leading-relaxed mb-4">
                                Our journey started with a simple belief: that everyone deserves to feel confident and stylish in their own skin. We curate clothing that isn't just about the fabric, but about the expression of individuality.
                            </p>
                        </div>
                        <div className="bg-slate-100 rounded-3xl p-8 flex items-center justify-center">
                            <img
                                src="/images/about_us_swag.png"
                                alt="Cider Clothings Fashion"
                                className="rounded-2xl shadow-lg max-w-full h-auto"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 text-center">
                            <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm text-slate-900 mx-auto mb-6">
                                <FiTarget size={32} />
                            </div>
                            <h3 className="text-xl font-bold mb-4">Our Mission</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">
                                To dominate the Sri Lankan fashion landscape by providing world-class trendy apparel at prices that make sense.
                            </p>
                        </div>
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 text-center">
                            <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm text-slate-900 mx-auto mb-6">
                                <FiHeart size={32} />
                            </div>
                            <h3 className="text-xl font-bold mb-4">Our Commitment</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">
                                We are committed to ethical sourcing and sustainable growth, ensuring that our success benefits our community.
                            </p>
                        </div>
                        <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100 text-center">
                            <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm text-slate-900 mx-auto mb-6">
                                <FiShield size={32} />
                            </div>
                            <h3 className="text-xl font-bold mb-4">Quality First</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">
                                Every piece of clothing undergoes rigorous quality checks to ensure you receive nothing but the best.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Section */}
            <div className="max-w-3xl mx-auto mt-20 px-4">
                <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 text-center">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Us</h2>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-8 text-gray-600">
                        <div>
                            <span className="block font-semibold text-gray-900">Address</span>
                            Matara, Sri Lanka
                        </div>
                        <div>
                            <span className="block font-semibold text-gray-900">Email</span>
                            ciderclothings@gmail.com
                        </div>
                        <div>
                            <span className="block font-semibold text-gray-900">Phone</span>
                            +94 764305520
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-3xl mx-auto mt-12 text-center px-4">
                <p className="text-gray-500 text-sm">
                    Thank you for being part of the Cider Clothings family. Follow us for the latest trends!
                </p>
            </div>
        </div>
    );
};

export default AboutUsPage;
